import GoogleSignInButton from "./GoogleSignInButton";

export default GoogleSignInButton;
